/**
 * OceRead 品牌 - Tags 页面配置
 */
import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'

/**
 * OceRead 品牌特定主题配置
 */
export const theme = {
  popupTagBgColor: '#E9EDFD',
  popupTagColor: '#65686F',
  popupTagActiveColor: '#FFFFFF',

  filterBgColor: '#F5F7FB',
  filterActiveBgColor: '#E6ECFF',
  filterColor: '#65686F',
  filterActiveColor: '#6B92FD',
} as const

export const tagsConfig: TagsPageConfig = {
  theme,
  texts: tagsCommonConfig.texts,
}
